<div class="border">
    <div class="row">
        <div class="col-sm-3">
          <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
            <mat-label>TipoContenedor</mat-label>
            <mat-select required formControlName="TipoContenedor">
              <mat-option>seleccionar</mat-option>
              <mat-option value="TC01">20' Contenedor de 6.1 Mts de longitud</mat-option>
              <mat-option value="TC02">40' Contenedor de 12.2 Mts de longitud</mat-option>
              <mat-option value="TC03">45' Contenedor de 13.7 Mts de longitud</mat-option>
              <mat-option value="TC04">48' Contenedor de 14.6 Mts de longitud</mat-option>
              <mat-option value="TC05">53' Contenedor de 16.1 Mts de longitud</mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
            <mat-label>TipoCarro </mat-label>
            <input matInput aria-label="State" matInput formControlName="TipoContenedor"
              [matAutocomplete]="autoTipoContenedor">
            <span class="text-danger"
              *ngIf="FormCarro.controls.TipoContenedor.invalid && FormCarro.controls.TipoContenedor.touched">
              Campo requerido
            </span>
            <mat-autocomplete #autoTipoContenedor="matAutocomplete" [displayWith]="displayTipoContenedor">
              <mat-option *ngFor="let item of opcionesTipoContenedor | async" [value]="item.id" style="height: 35px;">
                <span> {{item.attributes?.clave}} - {{item.attributes?.tipo}}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      
        <div class="col-sm-3">
          <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
            <mat-label>PesoContenedorVacio</mat-label>
            <input required type="number" formControlName="PesoContenedorVacio" matInput>
          </mat-form-field>
        </div>
      
        <div class="col-sm-3">
          <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
            <mat-label>PesoNetoMercancia</mat-label>
            <input required type="number" formControlName="PesoNetoMercancia" matInput>
          </mat-form-field>
        </div>
    </div>    
</div>